module.exports = __webpack_public_path__ + "img/consultation_pink.62d1653e.png";